import { render } from "./WikiPage.vue?vue&type=template&id=69ba5eea&scoped=true"
import script from "./WikiPage.vue?vue&type=script&lang=js"
export * from "./WikiPage.vue?vue&type=script&lang=js"

import "./WikiPage.vue?vue&type=style&index=0&id=69ba5eea&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ba5eea"]])

export default __exports__